import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "content"];
  static values = { expanded: Boolean };

  toggle() {
    const chevron = this.toggleTarget.querySelector("svg");

    if (this.expandedValue) {
      chevron.classList.add("rotate-180");
      this.contentTarget.style.gridTemplateRows = "0fr";
    } else {
      chevron.classList.remove("rotate-180");
      this.contentTarget.style.gridTemplateRows = "1fr";
    }

    this.expandedValue = !this.expandedValue;
  }
}
